module.exports = __webpack_public_path__ + "static/media/rekomendasi.9627a8a6.svg";